module.exports = __webpack_public_path__ + "img/简单易学@3x.c8fd0dc5.png";